export const frontmatter = {
  title: "First Epoch After Listing",
  order: 13,
}

You need to distribute the emissions for the first epoch after listing your token.

1. Copy the pair address.
2. Go to Voter > Read > Gauges > Get the gauge address.
3. Move to Voter > Write. Connect your wallet.
4. Paste the gauge address in Voter > Write > Distribute.
